const createPeriod = (periodData) => {
  return {
    periodId: periodData.periodId,
    pageTitle: periodData.pageTitle,
    archiveTitle: periodData.archiveTitle,
  };
};

const createPeriods = (periodsData) => {
  return periodsData.map((periodData) => createPeriod(periodData));
};


export {
  createPeriod,
  createPeriods,
};
